import projection from '../generated/pwj501f1.json'; import { AcceptanceManifest } from '../types';
export const pwj501f1AcceptanceManifest = projection as AcceptanceManifest;
